import axios from 'axios'

const ANONYMOUS_USER = {
  first_name: 'Anonymous',
  last_name: 'User',
  role: 'unauthorized',
  city: 'Unknown',
  isAnonymous: true,
}

export const state = {
  isAuthorized: (getSavedState('auth.currentUser') || {}).id !== undefined,
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_AUTHORIZED(state, newValue) {
    state.isAuthorized = true
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },

  SET_UNAUTHORIZED(state) {
    state.isAuthorized = false
    state.currentUser = ANONYMOUS_USER
    saveState('auth.currentUser', ANONYMOUS_USER)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return state.isAuthorized
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs current user in
  logIn({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/auth/login', { email, password })
      .then((response) => {
        const user = response.data
        commit('SET_AUTHORIZED', user)
        return user
      })
  },

  // Reminds user password
  remindPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/auth/password/remind', { email })
      .then((response) => {
        return response
      })
  },

  // Changes user password
  passwordChange(
    { commit, dispatch, getters },
    { email, password, token } = {},
  ) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/auth/password/change', { email, password, token })
      .then((response) => {
        return response
      })
  },

  // Logs current user out
  logOut({ commit }) {
    return axios.get('/api/auth/logout').then((response) => {
      commit('SET_UNAUTHORIZED')
    })
  },

  reloadLogin({ commit, state }) {
    return axios
      .get('/api/auth/login')
      .then((response) => {
        const user = response.data
        commit('SET_AUTHORIZED', user)
        return user
      })
      .catch((error) => {
        commit('SET_UNAUTHORIZED')
        console.warn(error)
        return null
      })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state, dispatch }) {
    if ((state.currentUser || {}).isAnonymous) return Promise.resolve(null)

    return axios
      .get('/api/auth/login')
      .then((response) => {
        const user = response.data
        commit('SET_AUTHORIZED', user)
        return user
      })
      .catch((error) => {
        commit('SET_UNAUTHORIZED')
        console.warn(error)
        window.location = '/'
        return null
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  const token = state.currentUser ? state.currentUser.api_token : ''
  axios.defaults.headers.common.Authorization = token ? `Token ${token}` : ''
}
